module.exports = __webpack_public_path__ + "img/__icon_MANY_TYPES.5cb070e3.svg";